module.exports = __webpack_public_path__ + "static/media/avast-vince-spaceX.c3550e6a.jpg";